export const subNavData = {
  media: [
    {
      title: 'Live TV',
      url: 'videos/live'
    },
    {
      title: 'Audio',
      url: 'audio'
    }
  ],
  politics: [
    {
      title: 'SCOTUS',
      url: 'politics/supreme-court'
    },
    {
      title: 'Congress',
      url: 'politics/congress'
    },
    {
      title: 'Facts First',
      url: 'election/2024'
    },
    {
      title: '2024 Elections',
      url: 'politics/supreme-court'
    }
  ],
  main: [
    {
      title: 'US',
      url: 'us',
      sublinks: [
        {
          title: 'Crime + Justice',
          url: 'specials/us/crime-and-justice'
        },
        {
          title: 'Energy + Environment',
          url: 'us/energy-and-environment'
        },
        {
          title: 'Extreme Weather',
          url: 'weather'
        },
        {
          title: 'Space + Science',
          url: 'specials/space-science'
        }
      ]
    },
    {
      title: 'World',
      url: 'world',
      sublinks: [
        {
          title: 'Africa',
          url: 'africa'
        },
        {
          title: 'Americas',
          url: 'americas'
        },
        {
          title: 'Asia',
          url: 'asia'
        },
        {
          title: 'Australia',
          url: 'australia'
        },
        {
          title: 'China',
          url: 'china'
        },
        {
          title: 'Europe',
          url: 'europe'
        },
        {
          title: 'India',
          url: 'india'
        },
        {
          title: 'Middle East',
          url: 'middle-east'
        },
        {
          title: 'United Kingdom',
          url: 'uk'
        }
      ]
    },
    {
      title: 'Politics',
      url: 'politics',
      sublinks: [
        {
          title: 'SCOTUS',
          url: 'politics/supreme-court'
        },
        {
          title: 'Congress',
          url: 'politics/congress'
        },
        {
          title: 'Facts First',
          url: 'specials/politics/fact-check-politics'
        },
        {
          title: '2024 Elections',
          url: 'election/2024'
        }
      ]
    },
    {
      title: 'Business',
      url: 'business',
      sublinks: [
        {
          title: 'Tech',
          url: 'business/tech'
        },
        {
          title: 'Media',
          url: 'business/media'
        },
        {
          title: 'Calculators',
          url: 'business/financial-calculators'
        },

        {
          title: 'Videos',
          url: 'business/videos'
        }
      ]
    },
    {
      title: 'Markets',
      url: 'markets',
      sublinks: [
        {
          title: 'Pre-markets',
          url: 'markets/premarkets'
        },
        {
          title: 'After-Hours',
          url: 'markets/after-hours'
        },
        {
          title: 'Market Movers',
          url: 'data/hotstocks/'
        },

        {
          title: 'Fear & Greed',
          url: 'markets/fear-and-greed'
        },
        {
          title: 'World Markets',
          url: 'https://money.cnn.com/data/world_markets/americas/'
        },
        {
          title: 'Investing',
          url: 'business/investing'
        },
        {
          title: 'Markets Now',
          url: 'business/markets-now'
        },
        {
          title: 'Before the Bell',
          url: 'business/before-the-bell'
        },
        {
          title: 'Nightcap',
          url: 'business/markets/nightcap'
        }
      ]
    },
    {
      title: 'Opinion',
      url: 'opinions',
      sublinks: [
        {
          title: 'Political Op-Eds',
          url: 'opinions/opinion-politics'
        },
        {
          title: 'Social Commentary',
          url: 'opinions/opinion-social-issues'
        }
      ]
    },
    {
      title: 'Health',
      url: 'health',
      sublinks: [
        {
          title: 'Life, But Better',
          url: 'interactive/life-but-better/'
        },
        {
          title: 'Fitness',
          url: 'specials/health/fitness-life-but-better'
        },
        {
          title: 'Food',
          url: 'specials/health/food-life-but-better'
        },
        {
          title: 'Sleep',
          url: 'specials/health/sleep-life-but-better'
        },
        {
          title: 'Mindfulness',
          url: 'specials/health/mindfulness-life-but-better'
        },
        {
          title: 'Relationships',
          url: 'specials/health/relationships-life-but-better'
        }
      ]
    },
    {
      title: 'Entertainment',
      url: 'entertainment',
      sublinks: [
        {
          title: 'Movies',
          url: 'entertainment/movies'
        },
        {
          title: 'Television',
          url: 'entertainment/tv-shows'
        },
        {
          title: 'Stars',
          url: 'entertainment/celebrities'
        }
      ]
    },
    {
      title: 'Tech',
      url: 'business/tech',
      sublinks: [
        {
          title: 'Innovate',
          url: 'business/tech/innovate'
        },
        {
          title: 'Gadget',
          url: 'business'
        },
        {
          title: 'Foreseeable Future',
          url: 'business/tech/foreseeable-future'
        },
        {
          title: 'Mission:Ahead',
          url: 'business/tech/mission-ahead'
        },
        {
          title: 'Upstarts',
          url: 'business'
        },
        {
          title: 'Work Transformed',
          url: 'business/work-transformed'
        },
        {
          title: 'Innovative Cities',
          url: 'business/tech/innovative-cities'
        }
      ]
    },
    {
      title: 'Style',
      url: 'style',
      sublinks: [
        {
          title: 'Arts',
          url: 'style/arts'
        },
        {
          title: 'Design',
          url: 'style/design'
        },
        {
          title: 'Fashion',
          url: 'style/fashion'
        },
        {
          title: 'Architecture',
          url: 'style/architecture'
        },
        {
          title: 'Luxury',
          url: 'style/luxury'
        },
        {
          title: 'Beauty',
          url: 'style/beauty'
        },
        {
          title: 'Video',
          url: 'style/videos'
        }
      ]
    },
    {
      title: 'Travel',
      url: 'travel',
      sublinks: [
        {
          title: 'Destinations',
          url: 'travel/destinations'
        },
        {
          title: 'Food and Drink',
          url: 'travel/food-and-drink'
        },
        {
          title: 'Stay',
          url: 'travel/stay'
        },
        {
          title: 'News',
          url: 'travel/news'
        },
        {
          title: 'Videos',
          url: 'travel/videos'
        }
      ]
    },

    {
      title: 'Sports',
      url: 'https://bleacherreport.com/',
      sublinks: [
        {
          title: 'Pro Football',
          url: 'https://bleacherreport.com/nfl'
        },
        {
          title: 'College Football',
          url: 'https://bleacherreport.com/college-football'
        },
        {
          title: 'Basketball',
          url: 'https://bleacherreport.com/nba'
        },
        {
          title: 'Baseball',
          url: 'https://bleacherreport.com/mlb'
        },
        {
          title: 'Soccer',
          url: 'https://bleacherreport.com/world-football'
        },
        {
          title: 'Olympics',
          url: 'sport/paris-olympics-2024'
        },
        {
          title: 'Hockey',
          url: 'https://bleacherreport.com/nhl'
        }
      ]
    },
    {
      title: 'Videos',
      url: 'videos',
      sublinks: [
        {
          title: 'Live TV',
          url: 'videos/live'
        },
        {
          title: 'CNN Headlines',
          url: 'videos/fast/cnn-headlines'
        },
        {
          title: 'CNN Max',
          url: 'https://www.max.com/channel/cnn-max'
        },
        {
          title: 'Digital Studies',
          url: 'specials/digital-studios'
        },
        {
          title: 'CNN Films',
          url: 'specials/videos/digital-shorts'
        },
        {
          title: 'HLN',
          url: 'specials/videos/hln'
        },
        {
          title: 'TV Schedule',
          url: 'tv/schedule/cnn'
        },
        {
          title: 'TV Shows A-Z',
          url: 'specials/tv/all-shows'
        },
        {
          title: 'CNNVR',
          url: 'vr'
        }
      ]
    },
    {
      title: 'Audio',
      url: 'audio',
      sublinks: []
    },

    {
      title: 'CNN Underscored',
      url: 'cnn-underscored/',
      sublinks: [
        {
          title: 'Electronics',
          url: 'cnn-underscored/electronics'
        },
        {
          title: 'Fashion',
          url: 'cnn-underscored/fashion'
        },
        {
          title: 'Beauty',
          url: 'cnn-underscored/beauty'
        },
        {
          title: 'Health & Fitness',
          url: 'cnn-underscored/health-fitness'
        },
        {
          title: 'Home',
          url: 'cnn-underscored/home'
        },
        {
          title: 'Reviews',
          url: 'cnn-underscored/reviews'
        },
        {
          title: 'Deals',
          url: 'cnn-underscored/deals'
        },
        {
          title: 'Money',
          url: 'cnn-underscored/money'
        },
        {
          title: 'Gifts',
          url: 'cnn-underscored/gifts'
        },
        {
          title: 'Travel',
          url: 'cnn-underscored/travel'
        },
        {
          title: 'Outdoors',
          url: 'cnn-underscored/outdoors'
        },
        {
          title: 'Pets',
          url: 'cnn-underscored/pets'
        },
        {
          title: 'CNN Store',
          url: 'https://store.cnn.com/?utm_source=cnn.com&utm_medium=referral&utm_campaign=navbar'
        }
      ]
    },
    {
      title: 'Coupons',
      url: 'https://coupons.cnn.com/',
      sublinks: []
    },
    {
      title: 'Weather',
      url: 'weather',
      sublinks: [
        {
          title: 'Climate',
          url: 'specials/world/cnn-climate'
        },
        {
          title: 'Storm Tracker',
          url: 'interactive/storm-tracker/'
        },
        {
          title: 'Wildfire Tracker',
          url: 'interactive/2020/weather/wildfire-and-air-quality-tracker/'
        },
        {
          title: 'Video',
          url: 'specials/weather/video'
        }
      ]
    },

    {
      title: 'About CNN',
      url: 'about',
      sublinks: [
        {
          title: 'Photos',
          url: 'world/photos'
        },
        {
          title: 'Investigations',
          url: 'us/cnn-investigates'
        },
        {
          title: 'CNN Profiles',
          url: 'profiles'
        },
        {
          title: 'CNN Leadership',
          url: 'profiles/cnn-leadership'
        },
        {
          title: 'CNN Newsletters',
          url: 'newsletters'
        },
        {
          title: 'Work for CNN',
          url: 'https://careers.wbd.com/cnnjobs'
        }
      ]
    }
  ]
};
